import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const COMPETITION_CATEGORIES_REQUEST =
         'FETCH_REPORTS_COMPETITION_CATEGORIES_REQUEST';
export const COMPETITION_CATEGORIES_FAILURE =
         'FETCH_REPORTS_COMPETITION_CATEGORIES_FAILURE';
export const COMPETITION_CATEGORIES_SUCCESS =
         'FETCH_REPORTS_COMPETITION_CATEGORIES_SUCCESS';

export const fetchCompetitionCategoriesReport = (competition, category) => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(
          apiRequestOptions(apiPath.REPORTS.COMPETITION_CATEGORIES, null, {
            params: { competition, category },
            isBlob: true
          })
        )
          .then(transformHttpResponse)
          .then(response => {
            const content = response.headers['content-type'];
            const contentDisposition = response.headers['content-disposition'] || '';
            const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
            const filename = filenameMatch ? filenameMatch[1] : 'report.pdf';
                download(response.data, filename, content);
            dispatch(fetchSuccess());
          })
          .catch(error => transformHttpResponse(error.response))
          .catch(error => {
            dispatch(fetchFailure(error));
            dispatch(errorRequestHandler(error));
          });
    }
};

const fetchRequest = () => ({ type: COMPETITION_CATEGORIES_REQUEST });

const fetchFailure = error => ({type: COMPETITION_CATEGORIES_FAILURE, error,});

const fetchSuccess = () => ({type: COMPETITION_CATEGORIES_SUCCESS});
